import { render, staticRenderFns } from "./KabarBondowoso.vue?vue&type=template&id=7ac7c477&scoped=true"
import script from "./KabarBondowoso.vue?vue&type=script&lang=js"
export * from "./KabarBondowoso.vue?vue&type=script&lang=js"
import style0 from "./KabarBondowoso.vue?vue&type=style&index=0&id=7ac7c477&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac7c477",
  null
  
)

export default component.exports